module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"FormPhone.select":"Selecione","FormPhone.House":"Casa","FormPhone.Work":"Trabalho","FormPhone.FAX":"FAX","FormPhone.WhatsApp":"WhatsApp"},"en":{"FormPhone.select":"Select","FormPhone.House":"House","FormPhone.Work":"Work","FormPhone.FAX":"FAX","FormPhone.WhatsApp":"WhatsApp"}}')
  delete Component.options._Ctor
}
